import { CakeApiBase } from '../CakeApiBase';

export class VipApi extends CakeApiBase {
  async getLatestConfectioneryScore(): Promise<string> {
    return this.requestManager.get('vip/confectionery-score');
  }
}
